'use strict';

import React, {useCallback} from 'react';
import {h, Fragment} from 'preact';
import {trans} from '../../../l10n';
import AvailableVinnitsa from './AvailableVinnitsa';

export default function Availability(props) {
    if (props.hide_availability) {
        return '';
    }

    if (false && global.config.isVinnitsa && props.view === 'grid' && props.product.statusAvailable) {
        return <AvailableVinnitsa {...props.product} />;
    }

    const check = useCallback(
        ev => {
            ev.preventDefault();

            window.checkGoodQuantity(ev, props.product.id);
        },
        [props.product.id]
    );

    if (global.config.isMaster && props.product.quantityAvailable && props.product.available) {
        return (
            <div className='product-availability'>
                {props.product.isCountVisible ? (
                    <p className='goods-quantity' dangerouslySetInnerHTML={{__html: props.product.availableCount}}></p>
                ) : (
                    <a
                        className='link-quantity'
                        href='#'
                        title={trans('catalog.click_to_see_count')}
                        onClick={check}
                        dangerouslySetInnerHTML={{
                            __html: props.product.available + '<span>?</span>',
                        }}></a>
                )}
            </div>
        );
    }

    if (props.product.available) {
        return <div className='in_stock' style={{ 'font-size': '11px', 'padding-bottom': '6px'}} dangerouslySetInnerHTML={{__html: props.product.available}}></div>;
    }

    return '';
}
